import { deepEqual } from 'fast-equals';
import microMemoize from 'micro-memoize';
function memoize(fn) {
    // @ts-ignore: library's package.json is wrongly configured
    return microMemoize(fn, { isEqual: deepEqual, maxSize: 15 });
}
export { memoize, };
//# sourceMappingURL=memoize.js.map